import { useEffect, useState } from "react";

export default function AnimatedCounter({ value, duration = 1200, prefix = "", suffix = "" }) {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const start = 0;
    const startTime = performance.now();
    let raf = 0;
    const tick = (now) => {
      const t = Math.min((now - startTime) / duration, 1);
      // cubic ease-out
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(Math.round(start + (value - start) * eased));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value, duration]);

  return (
    <span className="font-mono tabular-nums">
      {prefix}
      {display.toLocaleString("en-AU")}
      {suffix}
    </span>
  );
}
